import logo from '../../images/logo-keralty.png'
import acao from '../../images/initial.jpg'
function Initial(){
    return(

        <div className="w-full bg-cover bg-center h-home flex lg:flex-row flex-col lg:justify-evenly justify-center "style={{ backgroundImage: `url(${acao})` }}>
        <div className="flex-1 flex flex-col p-5 bg-white bg-opacity-80 rounded-r-full items-center justify-center">
            <img alt='Logo Keralty' src={logo} ></img>
            <h3 className=' text-second text-center font-rubik lg:text-2xl md:text-[20px]'>Promovemos o bem-estar de paciente em cuidados paliativos com muito amor, carinho e dedicação</h3>
        </div>
        <div className="p-5 flex-1 flex items-center justify-center flex-col hidden lg:flex">
                        <h3 className=' text-white text-center font-bold font-rubik lg:text-5xl md:text-[20px]'>Faça sua doação agora mesmo!</h3>
                        <h3 className=' text-white text-center font-rubik lg:text-2xl md:text-[20px] mt-10'>Contribua com nossa associação clicando:</h3>
                        <button className="font-bold bg-primary mt-10 text-white px-20 py-3 rounded-full hover:bg-white hover:text-primary transition">Abraça Keralty</button>

        </div>
        </div>

    );
}

export default Initial;